import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Footer, Navbar } from "../components";
import toast from "react-hot-toast";

const ContactPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    contact: "",
    email: "",
    query: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      let message = formData.query;
      if (formData.contact) {
        message += `\n\nContact Number: ${formData.contact}`;
      }

      const response = await fetch(
        "https://qlnluxi50c.execute-api.us-east-1.amazonaws.com/enquiry",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: formData.name,
            email: formData.email,
            message: message,
          }),
        }
      );

      if (response.ok) {
        toast.success("Enquiry sent successfully!");
        setFormData({
          name: "",
          contact: "",
          email: "",
          query: "",
        });
        // Redirect to home after a short delay
        setTimeout(() => {
          navigate("/");
        }, 1500);
      } else {
        throw new Error("Failed to send enquiry");
      }
    } catch (error) {
      console.error("Error sending enquiry:", error);
      toast.error("Failed to send enquiry. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="container my-3 py-3">
        <h1 className="text-center">Contact Us</h1>
        <hr />
        <div className="row my-4 h-100">
          <div className="col-md-6 col-lg-6 col-sm-8 mx-auto">
            <form onSubmit={handleSubmit}>
              <div className="form-group my-3">
                <label htmlFor="name" className="mb-1">
                  Name *
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  placeholder="Enter your name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group my-3">
                <label htmlFor="email" className="mb-1">
                  Email *
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  placeholder="name@example.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group my-3">
                <label htmlFor="contact" className="mb-1">
                  Contact Number
                </label>
                <input
                  type="tel"
                  className="form-control"
                  id="contact"
                  name="contact"
                  placeholder="Enter your contact number"
                  value={formData.contact}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group my-3">
                <label htmlFor="query" className="mb-1">
                  Message (min 10 characters) *
                </label>
                <textarea
                  rows={5}
                  className="form-control"
                  id="query"
                  name="query"
                  placeholder="Enter your message"
                  value={formData.query}
                  onChange={handleChange}
                  minLength={10}
                  required
                />
              </div>
              <div className="text-center">
                <button
                  className="my-2 px-4 mx-auto btn btn-dark"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Sending..." : "Send"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContactPage;
